export class APIError extends Error {
  constructor(public status: number, public body: unknown) {
    super(`API error ${status}`)
  }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const r = await fetch(path, {
    ...init,
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
      ...init.headers,
    },
  })
  if (!r.ok) {
    let body: unknown = null
    try { body = await r.json() } catch { /* ignore */ }
    throw new APIError(r.status, body)
  }
  if (r.status === 204) return undefined as T
  return (await r.json()) as T
}
